(function () {
  var section = document.querySelector('.blog-lista');
  if (!section) return;

  var grid      = section.querySelector('#blog-grid');
  var cards     = grid ? Array.prototype.slice.call(grid.querySelectorAll('.blog-lista__card')) : [];
  var tabs      = Array.prototype.slice.call(section.querySelectorAll('.blog-lista__tab'));
  var moreWrap  = section.querySelector('.blog-lista__more');
  var moreBtn   = section.querySelector('.blog-lista__more-btn');
  var baseLimit = parseInt(section.getAttribute('data-limit'), 10) || 12;
  var activeCat = 'all';

  function getVisibleCards() {
    return cards.filter(function (card) {
      if (activeCat === 'all') return true;
      var cats = (card.getAttribute('data-cats') || '').split(',');
      return cats.indexOf(activeCat) !== -1;
    });
  }

  function applyVisibility() {
    var matching = getVisibleCards();
    var shown = 0;

    cards.forEach(function (card) {
      if (activeCat !== 'all') {
        var cats = (card.getAttribute('data-cats') || '').split(',');
        if (cats.indexOf(activeCat) === -1) {
          card.style.display = 'none';
          return;
        }
      }
      if (shown < baseLimit) {
        card.style.display = '';
        shown++;
      } else {
        card.style.display = 'none';
      }
    });

    if (moreWrap) {
      moreWrap.style.display = matching.length > baseLimit ? '' : 'none';
    }
  }

  /* Tab switching */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      activeCat = tab.getAttribute('data-cat');
      baseLimit = parseInt(section.getAttribute('data-limit'), 10) || 12;
      applyVisibility();
    });
  });

  /* Show more (+12) */
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      baseLimit += parseInt(section.getAttribute('data-limit'), 10) || 12;
      applyVisibility();
    });
  }

  applyVisibility();
})();
